import axios from 'axios'
import { get, post, del,getfile } from '@/http/request'
import { HOST } from '@/http/config'

// 列表
export function getFloodPreventionlist(params) {
  return get(`${HOST}basis-flood-prevention/list`, params)
}
// 根据id删除
export function delFloodPrevention(params) {
  return del(`${HOST}basis-flood-prevention/delete`, params)
}
// 详情
export function getFloodPreventionDetails(params) {
  return get(`${HOST}basis-flood-prevention/get`, params)
}
// 新增
export function saveFloodPrevention(params) {
  return post(`${HOST}basis-flood-prevention/save`, params)
}
// 修改
export function updateFloodPrevention(params) {
  return post(`${HOST}basis-flood-prevention/update`, params)
}
//历史修改版本列表
export function getHistoryList(params) {
  return get(`${HOST}basis-flood-prevention-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
  return get(`${HOST}basis-flood-prevention-history/get`, params)
}
// 导出
export function Export(params) {
  return getfile(`${HOST}basis-flood-prevention/export`, params)
}



// WEBPACK FOOTER //
// ./src/views/baseInfoManagement/floodControl/api.js